import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { validateFields } from './FormValidation';
import { Prompt } from 'react-router';
import history from '../../../../..//history';
import { Link } from 'react-router-dom';
import { checkIfApiLoading, checkPageActionAccess, checkPageAccess } from '../../../../../utils/helper';
import { notificationError } from '../../../../../redux/actions/Notification/notificationActions';
import { getBrandDetail, postNewBrand, putUpdateBrand, brandTriggerHighlight } from '../../../../../redux/actions/Brand/brandActions';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import MainPage from '../../../../../components/MainPage/MainPage';
import MainPageHeader from '../../../../../components/MainPageHeader/MainPageHeader';
import MainPageBody from '../../../../../components/MainPageBody/MainPageBody';
import { getFactoryId } from '../../../../../utils/helper.js';
import dictionary from '../../../../../redux/actions/Translation/dictionary'
import './BrandForm.scss';
import { formatDate } from '../../../../../utils/date';

class BrandForm extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            translations: {
                ...this.convert()
            },
            translationTimestamp: undefined,
            id: null,
            title: null,
            saveLabel: null,
            factoryId: null,
            hasFormChanges: false,
            disablePrompt: false,
            form: {
                code: null,
                name: null,
                company: null,
                website: null,
                desc: null,
                isActive: 1,
            },
            formErrors: [],
        }
    }

    convert = () => {
        let { NOTIFICATIONS: { are_you_sure_to_leave_this_page, brand_code_exists }, ADD_BRAND, EDIT_BRAND, SAVE, ADD, CANCEL, STATUS, Active, Inactive, UPDATED_BY, UPDATED_DATE, CREATED_BY, CREATED_DATE,
        BRAND_CODE,DISPLAY_NAME,COMPANY_NAME, WEBSITE,DESCRIPTION, SHORT_NAME_FOR_SYSTEM_DISPLAY
        } = dictionary.GET()
        return dictionary.TRANSLATE({
            are_you_sure_to_leave_this_page, brand_code_exists,
            ADD_BRAND, EDIT_BRAND, SAVE, ADD, CANCEL, STATUS, Active, Inactive, UPDATED_BY, UPDATED_DATE, CREATED_BY, CREATED_DATE,
            BRAND_CODE,DISPLAY_NAME,COMPANY_NAME, WEBSITE,DESCRIPTION, SHORT_NAME_FOR_SYSTEM_DISPLAY
        })
    }
    handleFormChange = ({ target }) => {
        let tmpForm = this.state.form;
        tmpForm[target.name] = target.value;
        this.setState({ form: tmpForm, hasFormChanges: true });
        this.removeErrorOnChange(target.name);
    };

    handleCodeFormChange = ({ target }) => {
        let value = null;
        if (target.value.indexOf(" ") >= 0) {
            value = target.value.replace(" ", "");
        }
        else {
            value = target.value;
        }
        let tmpForm = this.state.form;
        tmpForm[target.name] = value;
        this.setState({ form: tmpForm, hasFormChanges: true });
        this.removeErrorOnChange(target.name);
    };

    handleRadioButtonChange = ({ target }) => {
        let tmpForm = this.state.form;
        tmpForm[target.name] = parseInt(target.value);
        this.setState({ form: tmpForm, hasFormChanges: true });
        this.removeErrorOnChange(target.name);
    };

    checkIfApiLoading() {
        let flag = checkIfApiLoading([
            this.props.brandDetailLoading,
        ]);
        return flag;
    }

    checkBrandCodeTrigger() {
        let { translations } = this.state
        if (this.props.triggerHighlight) {
            let errors = [];
            let formValid = false;
            errors.push({ name: 'code', message: translations.brand_code_exists });

            let tmpFormError = {
                valid: formValid,
                errors: errors
            }

            this.setState({ formErrors: tmpFormError.errors }, () => {
                this.props.brandTriggerHighlight(false);
            });
        }
    }

    componentDidMount() {
        let { translations } = this.state
        document.body.style.backgroundColor = "#F7F7FB";
        let factoryId = getFactoryId();
        if (this.props.match.params.id) {
            this.props.getBrandDetail(this.props.match.params.id);
            this.setState({ title: translations.EDIT_BRAND, saveLabel: translations.SAVE, id: this.props.match.params.id, factoryId: factoryId });
        }
        else {
            let factoryId = getFactoryId();
            this.setState({ title: translations.ADD_BRAND, saveLabel: translations.ADD, factoryId: factoryId });
        }
    }

    renderBooleanAsInteger(bool) {
        if (bool === true) {
            return 1
        }
        else {
            return 0
        }
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.brandDetail !== null && this.props.match.params.id !== null && this.props.match.params.id !== undefined) {
            let tmpForm = {
                code: nextProps.brandDetail.code,
                name: nextProps.brandDetail.name,
                company: nextProps.brandDetail.company,
                website: nextProps.brandDetail.website,
                desc: nextProps.brandDetail.desc,
                isActive: this.renderBooleanAsInteger(nextProps.brandDetail.isActive),
            };
            this.setState({ form: tmpForm });
        }
    }

    submitForm = () => {
        let payload = {
            ...this.state.form,
            factoryId: this.state.factoryId
        };
        let formValidation = validateFields(payload);
        this.setState({ formErrors: formValidation.errors });
        if (formValidation.valid) {

            this.setState({ disablePrompt: true }, () => {
                if (this.state.id === null) {
                    payload = {
                        ...payload,
                        companyName: payload.company
                    }
                    delete payload.isActive;
                    delete payload.company;
                    this.props.postNewBrand(payload);
                }
                else {
                    payload = {
                        ...payload,
                        companyName: payload.company
                    }
                    this.props.putUpdateBrand(this.state.id, payload);
                }
            })
        }
        else {
            this.props.notificationError(formValidation.errors[0].message);
        }
    }

    removeErrorOnChange(field) {
        let errors = this.state.formErrors.filter((item) => { return item.name !== field });
        this.setState({ formErrors: errors });
    }

    hasErrors = (field) => {
        let checkField = this.state.formErrors.filter((item) => { return item.name === field });
        if (checkField.length > 0) {
            return true
        }
        else {
            return false;
        }
    }



    renderText(field) {
        if (field === null || field === '') {
            return '-'
        }
        else {
            //   return field != undefined ? field.toString().translate() : field
            return field
        }
    }

    resetForm() {
        let tmpForm = {
            code: null,
            name: null,
            company: null,
            website: null,
            desc: null,
            isActive: 1,
        }
        this.setState({ form: tmpForm });
    }



    renderDate(date) {
        if (date !== null) {
            let timezone = moment.parseZone(date).format('Z');
            let dateTimeOnly = moment.parseZone(date).format('YYYY-MM-DD HH:mm:ss') + '+00:00';
            return moment(dateTimeOnly).utcOffset(timezone).format('DD-MM-YYYY');
        }
        else {
            return '-';
        }
    }

    getErrors = (field) => {
        let checkField = this.state.formErrors.filter((item) => { return item.name === field });
        let errorString = null;
        checkField.map((item) => {
            errorString += item.message + '. ';
            return '';
        })
        return errorString;
    }

    renderStatusForm() {
        let { translations } = this.state
        return (
            <div>
                <div className="space"></div>
                <Paper className="body end">
                    <div className="form-input">
                        <FormControl className="control-row" fullWidth>
                            <Grid container spacing={0}>
                                <Grid item xs={5}>
                                    <FormLabel className="status" component="legend">{translations.STATUS}</FormLabel>
                                </Grid>
                                <Grid item xs={7}>
                                    <RadioGroup onChange={this.handleRadioButtonChange} name="isActive" className="radioButton" row value={this.state.form.isActive}>
                                        <FormControlLabel value={1} control={<Radio color="primary" />} label={translations.Active} />
                                        <FormControlLabel value={0} control={<Radio color="primary" />} label={translations.Inactive} />
                                    </RadioGroup>
                                </Grid>
                                <Grid className="statusDetails" item xs={12}>
                                    <FormLabel component="legend">{translations.UPDATED_BY}: {this.props.brandDetail ? this.renderText(this.props.brandDetail.updatedBy) : null}</FormLabel>
                                </Grid>
                                <Grid className="statusDetails" item xs={12}>
                                    <FormLabel component="legend">{translations.UPDATED_DATE}: {this.props.brandDetail ? formatDate(this.props.brandDetail.updatedDt) : null}</FormLabel>
                                </Grid>
                                <Grid className="statusDetails" item xs={12}>
                                    <FormLabel component="legend">{translations.CREATED_BY}: {this.props.brandDetail ? this.renderText(this.props.brandDetail.createdBy) : null}</FormLabel>
                                </Grid>
                                <Grid className="statusDetails" item xs={12}>
                                    <FormLabel component="legend">{translations.CREATED_DATE}: {this.props.brandDetail ? formatDate(this.props.brandDetail.createdDt) : null}</FormLabel>
                                </Grid>
                            </Grid>
                        </FormControl>
                    </div>
                </Paper>
            </div>
        )
    }

    componentDidUpdate = () => {
        let { translations } = this.state
        if (this.props.translation && this.props.translation.translations.timeStamp != this.state.translationTimestamp) {
            this.setState({
                translationTimestamp: this.props.translation.translations.timeStamp,
                translations: Object.assign({}, { ...this.convert() }),
                title: this.props.match.params.id ? this.convert().EDIT_BRAND : this.convert().ADD_BRAND,
                saveLabel: this.props.match.params.id ? this.convert().SAVE : this.convert().ADD
            })
        }
        if (this.state.hasFormChanges) {
            window.onbeforeunload = () => { return translations.are_you_sure_to_leave_this_page }
        }
        else {
            window.onbeforeunload = undefined
        }
    }


    componentWillUnmount() {
        document.body.style.backgroundColor = null;
        this.resetForm();
        if (this.state.hasFormChanges) {
            window.onbeforeunload = undefined
        }
    }

    handleLinkClick = (url) => {
        if (this.state.id) {
            history.push(url);
        }
        else {
            this.setState({ disablePrompt: true }, () => {
                history.push(url);
            })
        }
    }

    content() {
        let {translations} = this.state
        return (
            <div>
                <Prompt
                    when={this.state.hasFormChanges && this.state.disablePrompt === false}
                    message={translations.are_you_sure_to_leave_this_page}
                />
                { this.checkBrandCodeTrigger()}
                <div className="form-container">
                    <Paper className="body">
                        <div className="title">{this.state.title}</div>
                        <div className="form-input">
                            <form autoComplete="off">
                                <div className="control-row" fullWidth>
                                    <TextField className={this.state.form.code ? 'label-green' : null} disabled={this.state.id} fullWidth error={this.hasErrors('code')} value={this.state.form.code} onChange={this.handleCodeFormChange} name="code" required placeholder={translations.SHORT_NAME_FOR_SYSTEM_DISPLAY} label={translations.BRAND_CODE} InputLabelProps={{ shrink: true }} />
                                </div>
                                <FormControl className="control-row" fullWidth>
                                    <TextField className={this.state.form.name ? 'label-green' : null} error={this.hasErrors('name')} value={this.state.form.name} onChange={this.handleFormChange} name="name" required placeholder={translations.SHORT_NAME_FOR_SYSTEM_DISPLAY} label={translations.DISPLAY_NAME} InputLabelProps={{ shrink: true }} />
                                </FormControl>
                                <FormControl className="control-row" fullWidth>
                                    <TextField className={this.state.form.company ? 'label-green' : null} error={this.hasErrors('company')} value={this.state.form.company} onChange={this.handleFormChange} name="company" label={translations.COMPANY_NAME} InputLabelProps={{ shrink: true }} />
                                </FormControl>
                                <FormControl className="control-row" fullWidth>
                                    <TextField className={this.state.form.website ? 'label-green' : null} error={this.hasErrors('website')} value={this.state.form.website} onChange={this.handleFormChange} name="website" label={translations.WEBSITE} InputLabelProps={{ shrink: true }} />
                                </FormControl>
                                <FormControl className="control-row" fullWidth>
                                    <TextField className={this.state.form.desc ? 'label-green' : null} error={this.hasErrors('desc')} value={this.state.form.desc} onChange={this.handleFormChange} name="desc" label={translations.DESCRIPTION} InputLabelProps={{ shrink: true }} />
                                </FormControl>
                            </form>
                        </div>
                    </Paper>
                    {this.state.id ? this.renderStatusForm() : null}
                </div>
                <div className="footer-actions">
                    <Grid container spacing={1}>
                        <Grid item xs={5} />
                        <Grid item xs={1}>
                            {/* <Link to="/configuration/machine-config/brands"> */}
                            <Button onClick={() => this.handleLinkClick('/configuration/machine-config/brands')} className="cancel" fullWidth variant="outlined">{translations.CANCEL}</Button>
                            {/* </Link> */}
                        </Grid>
                        <Grid item xs={1}>
                            <Button onClick={this.submitForm} className="save" fullWidth color="primary" variant="contained">{this.state.saveLabel}</Button>
                        </Grid>
                        <Grid item xs={5} />
                    </Grid>
                </div>
            </div>
        )
    }

    render() {
        return (
            <MainPage footer={false} className='brand-form'>
                <MainPageHeader title="Brand" search={false} />
                <MainPageBody>
                    {this.content()}
                </MainPageBody>
            </MainPage>
        );
    }
}

const mapStateToProps = state => {
    let { translationReducer } = state

    let apiLoading = {
        brandDetailLoading: state.brandListReducer.detailLoading,
    }
    let data = {
        brandDetail: state.brandListReducer.brandDetail,
        triggerHighlight: state.brandListReducer.triggerHighlight,
    }

    return {
        ...apiLoading,
        ...data,
        ...translationReducer

    }
}

const mapDispatchToProps = dispatch => {
    return {
        brandTriggerHighlight: (flag) => dispatch(brandTriggerHighlight(flag)),
        getBrandDetail: (id) => dispatch(getBrandDetail(id)),
        notificationError: (message) => dispatch(notificationError(message)),
        postNewBrand: (payload) => dispatch(postNewBrand(payload)),
        putUpdateBrand: (id, payload) => dispatch(putUpdateBrand(id, payload)),
    }
}

BrandForm = connect(mapStateToProps, mapDispatchToProps)(BrandForm);

export default BrandForm;
